<template>
  <section class="video-card">
    <div class="video-wrap">
      <span>{{ frame }}</span>
      <video
        ref="videoEl"
        controls
        :src="videoUrl"
        :controlslist="isVisualization ? 'nofullscreen' : ''"
        disablepictureinpicture
        playsinline
        @play="$emit('play')"
        @pause="$emit('pause')"
        @seeking="$emit('seeking', $event)"
        @ended="$emit('ended')"
        @loadeddata="$emit('ready', videoEl)"
      />
      <div v-if="fps != null" class="fps-chip" :title="`Prediction FPS: ${fps}`">
        <span class="fps-value">{{ fps }}</span>
        <span class="fps-unit">FPS</span>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'VideoPanel',
  props: {
    videoUrl: { type: String, default: '' },
    // Used to optionally hide fullscreen control via controlslist
    isVisualization: { type: Boolean, default: false },
    fps: { type: Number, default: null },
  },
  emits: ['ready', 'play', 'pause', 'seeking', 'ended'],
  setup() {
    const videoEl = ref(null);

    return { videoEl };
  },
};
</script>

<style scoped>
.video-card {
  border: 1px solid #e5e7eb;
  border-radius: var(--radius);
  background: #fff;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.video-wrap {
  position: relative;
  background: #fff;
  overflow: hidden;
  border-radius: 10px;
  height: 100%;
}

.video-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.placeholder {
  color: #d1d5db;
  font-size: var(--fs-md);
}

.fps-chip {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.65);
  color: #fff;
  font-weight: 600;
  line-height: 1;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  user-select: none;
}
.fps-value {
  font-size: clamp(13px, 1.15vw, 16px);
  font-variant-numeric: tabular-nums;
}
.fps-unit {
  font-size: clamp(10px, 0.85vw, 12px);
  opacity: 0.8;
  letter-spacing: 0.04em;
}
@media (max-width: 780px) {
  .video-wrap {
    height: 100%;
  }
}
</style>
